"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Given an UTC date string, returns whether the given
 * date is older than the current date
 */
function matchCurrentDate(date) {
    if (date === '') {
        return false;
    }
    var d = new Date(date);
    var now = new Date();
    // received badly formatted date string
    if (d instanceof Date && Number.isNaN(d.getTime())) {
        return false;
    }
    return d <= now;
}
exports.default = matchCurrentDate;
//# sourceMappingURL=matchCurrentDate.js.map